import React from 'react'

function Store() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is Store page</h1>
    </div>
  )
}

export default Store